import React from 'react'
import { CFView, CFImage, DefaultScreen, MobileScreen } from 'components'
import { mobilePromotion, promotions } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center>
          <CFImage src={mobilePromotion} w="100%" alt="Promotions" />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView column center m="0 auto" w="100%" maxWidth="1400px">
          <CFImage src={promotions} alt="Promotions" w="100%" />
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
